import { RcFile } from 'rc-upload/lib/interface';

export default function getBase64(file: RcFile, cbk: (result: string) => void) {
  const reader = new FileReader();
  reader.addEventListener('load', () => cbk(reader.result as string));
  reader.readAsDataURL(file);
}
